import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ng-pass-confirm',
  templateUrl: './ng-pass-confirm.component.html',
  styleUrls: ['./ng-pass-confirm.component.scss']
})
export class NgPassConfirmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    if(this.password != undefined && this.password != null){
      this.confirmationPassword = this.password
    }
  }

  @Input()
  password: string;

  @Input()
  actualPassword: string;

  @Input()
  submitAttempt: boolean = false;

  @Input()
  isValid: boolean;

  @Output()
  isValidChange = new EventEmitter<boolean>();

  @Output()
  passwordChange = new EventEmitter<string>();


  confirmationPassword : string;

  checkValidity(element) {
    this.isValid = !((!this.confirmationPassword || this.confirmationPassword.length == 0) && (this.submitAttempt || element.dirty || element.touched) ||
    !(!this.confirmationPassword || this.confirmationPassword.length == 0) && (this.password != this.confirmationPassword));
    this.isValidChange.emit(this.isValid);
    this.passwordChange.emit(this.password);
  }
}
